import AutoSizer from "react-virtualized-auto-sizer";
import React, {useEffect, useState, useMemo} from "react";
import styles from "./channels.module.css";
import {M3uMedia, M3uPlaylist} from "../../lib/m3u";
import {Row} from "./ChannelItem";
import {FixedSizeList as List, ListChildComponentProps} from "react-window";

function filterChannels(channels: M3uMedia[], filterValue: string): M3uMedia[] {
    return channels.filter(({location, mimeType, name}) =>
        (!filterValue || location?.toLowerCase().search(filterValue.toLowerCase()) !== -1) ||
        (!filterValue || mimeType.toLowerCase().search(filterValue.toLowerCase()) !== -1) ||
        (!filterValue || name?.toLowerCase().search(filterValue.toLowerCase()) !== -1)
    );
}

function applyFilters(channels: M3uMedia[], filterValues: string[]): M3uMedia[] {
    let result: M3uMedia[] = channels;
    filterValues.forEach(value => {
        result = filterChannels(result, value);
    });
    return result;
}

interface ItemProps {
    playlist: M3uPlaylist | null;
    RowActionsComponent?: React.ComponentType<{ data: M3uMedia }>;
    wordsFilter: string[];
}

export const ShowPlaylist = ({playlist, RowActionsComponent, wordsFilter}: ItemProps) => {
    const allChannels = useMemo(() => playlist ? playlist.medias : [], [playlist]);
    const [filteredChannels, setFilteredChannels] = useState(allChannels);

    useEffect(() => {
        const result = applyFilters(allChannels, wordsFilter);
        setFilteredChannels(result);
    }, [wordsFilter, allChannels]);

    const RowWrapper = React.useCallback(
        ({ data, index, style }: ListChildComponentProps<M3uMedia[]>) => (
            <Row
                data={data}
                index={index}
                style={style}
                RowActionsComponent={RowActionsComponent}
            />
        ),
        [RowActionsComponent]
    );

    return (
        <div className={styles.channelsListWrapper}>
            <AutoSizer>
                {({height, width}: {height: number; width: number}) => (
                    <List
                        className={styles.reactWindowList}
                        height={height}
                        itemData={filteredChannels}
                        itemCount={filteredChannels.length}
                        itemSize={60}
                        width={width}>
                        {RowWrapper}
                    </List>
                )}
            </AutoSizer>
        </div>
    );
};